import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import SidebarSteps from '../components/SidebarSteps';
// import useAuthRedirect from '../hooks/useAuthRedirect';
function SignUp4() {
   // useAuthRedirect();
   const [mnemonicPhrase, setMnemonicPhrase] = useState([]);
   const [errorMessage, setErrorMessage] = useState('');
   const navigate = useNavigate();
   const handleGetExistingPhrase = async () => {
      try {
         const jwt = localStorage.getItem('jwt');
         const response = await fetch('https://pt-api.digit-a.net/api/mnemonic-phrase/get', {
            method: 'GET',
            headers: {
               'Authorization': `Bearer ${jwt}`,
            },
         });
         const data = await response.json();
         if (response.ok && data.response) {
            const phraseArray = data.response.split(' ').filter(word => word.trim() !== '');
            setMnemonicPhrase(phraseArray);
            localStorage.setItem('mnemonicPhrase', data.response);
         }
      } catch (error) {
         console.error('Error getting existing phrase:', error);
      }
   };
   const handleGeneratePhrase = useCallback(async () => {
      try {
         setErrorMessage('');
         const demoToken = localStorage.getItem('demoToken');
         const jwt = localStorage.getItem('jwt');
         const userEmail = localStorage.getItem('userEmail');
         console.log('demoToken:', demoToken);
         console.log('jwt:', jwt);
         console.log('userEmail:', userEmail);
         if (!demoToken || demoToken.trim() === '') {
            setErrorMessage('The demoToken is not available or is empty in localStorage.');
            return;
         }
         if (!jwt || jwt.trim() === '') {
            setErrorMessage('The JWT is not available or is empty in localStorage.');
            return;
         }
         if (!userEmail || userEmail.trim() === '') {
            setErrorMessage('The email is not available or is empty in localStorage.');
            return;
         }
         // Verifica que el correo en el JWT coincida con userEmail
         const jwtPayload = JSON.parse(atob(jwt.split('.')[1]));
         if (jwtPayload.payload.email !== userEmail) {
            setErrorMessage('The email in the JWT does not match the registered one. Please restart the process.');
            return;
         }
         const response = await fetch('https://pt-api.digit-a.net/api/mnemonic-phrase/create', {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${jwt}`,
            },
            body: JSON.stringify({
               demoToken,
               email: userEmail,
            }),
         });
         const data = await response.json();
         console.log('Complete API response:', data, 'HTTP Status:', response.status);
         // If the phrase already exists, retrieve it instead of creating a new one
         if (response.status === 400 && data.message && data.message.includes('ya contiene frase')) {
            await handleGetExistingPhrase();
            return;
         }
         if (!response.ok) {
            throw new Error(
               `Error ${response.status}: ${data.message || response.statusText || 'Unknown error'}`
            );
         }
         if (!data.response || typeof data.response !== 'string') {
            throw new Error('The API response does not contain a valid mnemonic phrase.');
         }
         const phraseArray = data.response.split(' ').filter(word => word.trim() !== '');
         if (phraseArray.length === 0) {
            throw new Error('The returned mnemonic phrase is empty or invalid.');
         }
         setMnemonicPhrase(phraseArray);
         localStorage.setItem('mnemonicPhrase', data.response);
      } catch (error) {
         console.error('Detailed error:', error);
         setErrorMessage(`Error generating mnemonic phrase: ${error.message}`);
      }
   }, []);
   useEffect(() => {
      const demoToken = localStorage.getItem('demoToken');
      const jwt = localStorage.getItem('jwt');
      const userEmail = localStorage.getItem('userEmail');
      if (!demoToken || !jwt || !userEmail) {
         setErrorMessage('Incomplete data. Please complete the registration process.');
         navigate('/sign-up');
         return;
      }
      const existingPhrase = localStorage.getItem('mnemonicPhrase');
      if (existingPhrase) {
         const phraseArray = existingPhrase.split(' ').filter(word => word.trim() !== '');
         setMnemonicPhrase(phraseArray);
      } else {
         handleGeneratePhrase();
      }
   }, [navigate, handleGeneratePhrase]);
   return (
      <div className="container" page-key="signup4">
         <div className="row">
            <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
               <span className="mt-auto d-lg-none">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
               </span>
               <DarkModeBtn />
            </div>
            <div className="col-12">
               <div className="d-flex flex-column align-items-center align-items-lg-start w-100 gap-2 mb-3">
                  <h1 className="d-lg-none">Sign Up</h1>
                  <SidebarSteps activeStep={3} />
               </div>
               <div className="ppt_signup_steps">
                  <div className="ppt_signup_steps_info">
                     <h3 className="ppt_form_title mb-3 text-center text-lg-start">Recovery phrase</h3>
                     <p className="smallMe mb-4 mb-lg-5">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                     </p>
                     {errorMessage && (
                        <div className="alert alert-danger mb-5" role="alert">
                           {errorMessage}
                        </div>
                     )}
                     {mnemonicPhrase.length > 0 && (
                        <div className="ppt_gen_recophrase mb-5">
                           {mnemonicPhrase.map((word, index) => (
                              <span key={index} data-num={index + 1}>
                                 {word}
                              </span>
                           ))}
                        </div>
                     )}
                     <div className="ppt_input_style mb-5">
                        <NavLink to="/sign-up-5" className="ppt_btn_primary">
                           Continue
                        </NavLink>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
export default SignUp4;